export const API_KEY = 'abe00801c2dc570aee01aeaf512a2e77';
export const APP_VERSION = '1.1';
export const DB_NAME = 'db.json';
export const SAMPLE_MOVIES_URL = 'https://dl.dropboxusercontent.com/u/30115317/movies';
export const TMDB_URL = 'https://api.themoviedb.org/3';



/** WEBPACK FOOTER **
 ** ./src/components/_shared/constants.js
 **/